import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PriceRow,
  Label,
  AmountContainer,
  Amount,
  InfoIconContainer,
  Total,
  TotalWrapper,
} from './PriceBreakdown.styles';
import InfoIcon from '../../../assets/icons/Info';
import { COLORS } from '../../../styles/variables';

interface PriceLineProps {
  priceKey: string;
  label: string;
  shortDisclaimer: string;
  longDisclaimer: string;
  handleOpenModal: (e: any, legalText: string) => void;
  mainPrice: boolean;
  priceValue?: string;
}

const PriceLine: React.FC<PriceLineProps> = ({
  priceKey,
  label,
  priceValue,
  shortDisclaimer,
  longDisclaimer,
  handleOpenModal,
  mainPrice,
}) => {
  const { t } = useTranslation();
  const hasLongDisclaimer = useMemo(() => {
    return !!longDisclaimer?.length;
  }, [longDisclaimer?.length]);
  // use this for author entered price break down settings

  // Total Price (Bold)
  if (mainPrice) {
    return (
      <TotalWrapper key={priceKey}>
        <div>
          <Total>{label}</Total>
          {!!shortDisclaimer?.length && <Label color={COLORS.grey60}>{shortDisclaimer}</Label>}
        </div>
        <AmountContainer
          aria-label={`${label} legal disclaimer`}
          isSelectable={hasLongDisclaimer}
          onClick={hasLongDisclaimer ? (e) => handleOpenModal(e, longDisclaimer || '') : undefined}
        >
          <Total>{priceValue}</Total>{' '}
          <InfoIconContainer>
            {hasLongDisclaimer && <InfoIcon color={COLORS.grey60} size={16} />}
          </InfoIconContainer>
        </AmountContainer>
      </TotalWrapper>
    );
  }

  return (
    <PriceRow key={priceKey}>
      <div>
        <Label>{label}</Label>
        {!!shortDisclaimer?.length && <Label color={COLORS.grey60}>{shortDisclaimer}</Label>}
      </div>
      <AmountContainer
        aria-label={`Disclaimer about ${label}`}
        isSelectable={hasLongDisclaimer}
        onClick={hasLongDisclaimer ? (e) => handleOpenModal(e, longDisclaimer || '') : undefined}
      >
        <Amount>{priceValue}</Amount>{' '}
        <InfoIconContainer>
          {hasLongDisclaimer && <InfoIcon color={COLORS.grey60} size={16} />}
        </InfoIconContainer>
      </AmountContainer>
    </PriceRow>
  );
};

export default PriceLine;
